<template>
  <div class="FilesBar">
    <div class="FilesBar__element">
      <span v-if="showRecent">Recent</span>
      <span v-else>All files</span>
    </div>
    <div class="FilesBar__element FilesBar__element--right">
      <div @click="toggleShowRecent">
        <span v-if="showRecent">SHOW ALL</span>
        <span v-else>SHOW RECENT</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FilesBar',

  props: {
    showRecent: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    ...mapActions('filesRecent', [
      'toggleShowRecent'
    ])
  }
}
</script>

<style lang="scss">
@import 'FilesBar';
</style>
